import { render, staticRenderFns } from "./allocated.vue?vue&type=template&id=6ae42506"
import script from "./allocated.vue?vue&type=script&lang=js"
export * from "./allocated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports